import { PickupParticipantEditPage } from "components/shared/pickupParticipants";
import { EditInformationSection as InformationSection } from "./components/edit/informationSection";
import { EditPickupInformationSection as PickupInformationSection } from "./components/edit/pickupInformationSection";
import { EditRegistrationInformationSection as RegistrationInformationSection } from "./components/edit/registrationInformationSection";

export const EditPickupSportParticipant: React.FC = () => (
  <PickupParticipantEditPage
    kind="sport"
    variant="admin"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);
